export const UNAUTHORIZED_EVENT = 'unauthorized-event'
